(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9576],{

/***/ 72444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["id", "prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent", "text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function getPathStyles(offset, percent, strokeColor, strokeWidth, gapPosition) {
  var gapDegree = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;

  switch (gapPosition) {
    case "left":
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;

    case "right":
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;

    case "bottom":
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;

    default:
  }

  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;

  var pathStyle = _objectSpread(_objectSpread({
    // Stroke: typeof strokeColor === "string" && strokeColor
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s"
  }, typeof strokeColor === "string" && {
    stroke: strokeColor
  }), {}, {
    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px")
  });

  return {
    pathStyle: pathStyle,
    pathString: pathString
  };
}

var Circle = function Circle(_ref) {
  var id = _ref.id,
      prefixCls = _ref.prefixCls,
      strokeWidth = _ref.strokeWidth,
      trailWidth = _ref.trailWidth,
      gapDegree = _ref.gapDegree,
      gapPosition = _ref.gapPosition,
      trailColor = _ref.trailColor,
      strokeLinecap = _ref.strokeLinecap,
      style = _ref.style,
      className = _ref.className,
      strokeColor = _ref.strokeColor,
      percent = _ref.percent,
      text = _ref.text,
      restProps = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var _getPathStyles = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
      pathString = _getPathStyles.pathString,
      pathStyle = _getPathStyles.pathStyle;

  var getStokeList = function getStokeList() {
    var stackPtg = 0;
    var stroke = "";
    var pathStyles = getPathStyles(stackPtg, percent, strokeColor, strokeWidth, gapDegree, gapPosition);
    stackPtg += percent;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      className: "".concat(prefixCls, "-circle-path"),
      d: pathStyles.pathString,
      stroke: stroke,
      strokeLinecap: strokeLinecap,
      strokeWidth: strokeWidth,
      opacity: percent === 0 ? 0 : 1,
      fillOpacity: "0",
      style: pathStyles.pathStyle
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({
      className: "".concat(prefixCls, "-circle ").concat(className),
      viewBox: "0 0 100 100",
      style: style,
      id: id
    }, restProps), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        className: "".concat(prefixCls, "-circle-trail"),
        d: pathString,
        stroke: trailColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0",
        style: pathStyle
      }), getStokeList(), text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("text", {
        className: "text-base font-semibold",
        style: {
          dominantBaseline: "middle",
          textAnchor: "middle"
        },
        x: 50,
        y: 50,
        children: text
      })]
    }))
  });
};

Circle.defaultProps = {
  trailWidth: 1,
  trailColor: "#E5E5E5",
  style: {},
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeColor: "#007EFF",
  prefixCls: "rc-progress",
  percent: 0,
  className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Circle);

/***/ }),

/***/ 53667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/get.js
var get = __webpack_require__(99796);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Progress/index.js
var Progress = __webpack_require__(72444);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/molecules/StepBar/index.js
var StepBar = __webpack_require__(85504);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 2 modules
var react_select_esm = __webpack_require__(99973);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js + 3 modules
var index_a86253bb_esm = __webpack_require__(57003);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsChevronDown.js
var BsChevronDown = __webpack_require__(86456);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/Styles.module.scss
var Styles_module = __webpack_require__(72648);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/form/FormStep1.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var DropdownIndicator = function DropdownIndicator(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "px-1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BsChevronDown/* BsChevronDown */.I, {
        size: 13
      })
    })
  }));
};
var customStyles = {
  container: function container(provided) {
    return _objectSpread({}, provided);
  },
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderRadius: "30px",
      backgroundColor: "#fff",
      border: "0.5px solid #ddd",
      padding: "0px 16px",
      boxShadow: "none"
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: "#B7B7B7",
      fontSize: "16px",
      fontWeight: "400"
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: "4px 0px"
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderRadius: 20,
      overflow: "hidden"
    });
  },
  menuList: function menuList(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: 0
    });
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: "8px 16px",
      color: state.isSelected ? "#002A66" : "#333",
      background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
      fontWeight: state.isSelected ? "600" : "normal"
    });
  },
  input: function input(provided) {
    return _objectSpread({}, provided);
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      border: "none"
    };
  }
};

var Component = function Component(_ref2) {
  var countries = _ref2.countries,
      setForm1Data = _ref2.setForm1Data,
      form1Data = _ref2.form1Data,
      setDataBanks = _ref2.setDataBanks,
      errors = _ref2.errors,
      setErrors = _ref2.setErrors;
  var values = form1Data.values;

  var getFilteredBanks = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data, fieldName) {
      var newValues, newDataParams, newArray, _newArray, newForm1Data, response, newErrors, errorMessage;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(data && fieldName || data === "" && fieldName === "businessField")) {
                _context.next = 21;
                break;
              }

              newValues = form1Data && form1Data.values ? _objectSpread({}, form1Data.values) : {};
              newDataParams = form1Data && form1Data.params ? _objectSpread({}, form1Data.params) : {};

              if (fieldName === "incorporationCountry") {
                newDataParams.incorporation_country_id = data.id;
              }

              if (fieldName === "businessField") {
                newDataParams.business_field = data;
              }

              if (fieldName === "merchantAccount") {
                newDataParams.is_merchant_account = data;
              }

              if (fieldName === "memberNationalities") {
                newArray = data.length > 0 ? "[".concat(data.map(function (item) {
                  return item.id;
                }).join(","), "]") : null;
                newDataParams.member_country_ids = newArray;
              }

              if (fieldName === "partnerCountries") {
                _newArray = data.length > 0 ? "[".concat(data.map(function (item) {
                  return item.id;
                }).join(","), "]") : null;
                newDataParams.partner_country_ids = _newArray;
              }

              newValues[fieldName] = data;
              newForm1Data = {
                values: newValues,
                params: newDataParams
              };
              setForm1Data(newForm1Data);
              _context.prev = 11;
              _context.next = 14;
              return axios_default().get("".concat("https://core.test-lp.bbcincorp.com", "/api/onboarding/banking"), {
                params: newDataParams
              });

            case 14:
              response = _context.sent;

              if (response && response.data && response.data.data) {
                setDataBanks(response.data.data);

                if (response.data.data.length > 0) {
                  setErrors({});
                } else {
                  newErrors = _objectSpread({}, errors);
                  errorMessage = "";

                  if (fieldName === "incorporationCountry") {
                    errorMessage = "Sorry, we can not find banks which are matched with your country/jurisdiction, please choose another choices.";
                  }

                  if (fieldName === "businessField") {
                    errorMessage = "Sorry, your business activities cannot open bank account as it falls within the general blacklist of most banks.";
                  }

                  if (fieldName === "merchantAccount") {
                    errorMessage = "Sorry, we cannot find banks which match your requirement.";
                  }

                  if (fieldName === "merchantAccount") {
                    errorMessage = "Sorry, we cannot find banks which match your requirement.";
                  }

                  if (fieldName === "memberNationalities") {
                    errorMessage = "Sorry, we found no banks that support your selected nationalities.";
                  }

                  if (fieldName === "partnerCountries") {
                    errorMessage = "Sorry, we found no banks that support your selected countries of operation.";
                  }

                  newErrors[fieldName] = errorMessage;
                  setErrors(newErrors);
                }
              }

              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](11);
              console.error();

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 18]]);
    }));

    return function getFilteredBanks(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var setBusinessField = function setBusinessField(e) {
    setForm1Data(_objectSpread(_objectSpread({}, form1Data), {}, {
      values: _objectSpread(_objectSpread({}, form1Data.values), {}, {
        businessField: e.target.value
      })
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "1. Where was your company incorporated? Or, if you don\u2019t have a company yet, what country/jurisdiction do you plan to set up your business?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Styles_module_default()).selectBox,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          instanceId: "incorporation-nation",
          placeholder: "Choose your country",
          options: countries,
          classNamePrefix: "select",
          value: values.incorporationCountry ? values.incorporationCountry : "",
          onChange: function onChange(value) {
            return getFilteredBanks(value, "incorporationCountry");
          },
          className: (Styles_module_default()),
          components: {
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          styles: customStyles
        })
      }), errors.incorporationCountry && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500",
        children: errors.incorporationCountry
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "2. Please shortly describe your company's business activities:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: values.businessField,
          onChange: setBusinessField,
          onBlur: function onBlur(e) {
            return getFilteredBanks(e.target.value, "businessField");
          },
          className: "w-full rounded-[30px] border-[0.5px] border-[#ddd] bg-white py-2 px-4 text-base placeholder:font-normal placeholder:text-bbc-neutral-600 focus:outline-bbc-brand-200",
          placeholder: "Type business activity"
        })
      }), errors.businessField && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500",
        children: errors.businessField
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "3. Is a merchant account necessary for your business?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-2 gap-x-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return getFilteredBanks("1", "merchantAccount");
          },
          className: "border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(values.merchantAccount === "1" ? " bg-bbc-primary text-white" : ""),
          children: "Yes"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return getFilteredBanks("0", "merchantAccount");
          },
          className: "border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(values.merchantAccount === "0" ? " bg-bbc-primary text-white" : ""),
          children: "No"
        })]
      }), errors.merchantAccount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500",
        children: errors.merchantAccount
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "4. What are the nationalities of all your company\u2019s members incl. directors, shareholders, and beneficial owners?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Styles_module_default()).selectBox,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          isClearable: false,
          instanceId: "members-nation",
          menuPlacement: "auto",
          placeholder: "Choose nationality",
          options: countries,
          isMulti: true,
          classNamePrefix: "select",
          className: "placeholder:font-normal placeholder:text-bbc-neutral-600 ".concat((Styles_module_default())),
          components: {
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          styles: customStyles,
          value: values.memberNationalities || [],
          onChange: function onChange(value) {
            return getFilteredBanks(value, "memberNationalities");
          }
        })
      }), errors.memberNationalities && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500",
        children: errors.memberNationalities
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "5. Where do most of your major partners, suppliers, and customers reside?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Styles_module_default()).selectBox,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          isClearable: false,
          instanceId: "members-nation",
          menuPlacement: "auto",
          placeholder: "Choose nationality",
          options: countries,
          isMulti: true,
          classNamePrefix: "select",
          className: "".concat((Styles_module_default())),
          components: {
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          styles: customStyles,
          value: values.partnerCountries || [],
          onChange: function onChange(value) {
            return getFilteredBanks(value, "partnerCountries");
          }
        })
      }), errors.partnerCountries && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-2 min-h-[21px] text-sm tracking-[0.15px] text-red-500",
        children: errors.partnerCountries
      })]
    })]
  });
};

/* harmony default export */ var FormStep1 = (Component);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/form/FormStep2.js



function FormStep2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormStep2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormStep2_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormStep2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/exhaustive-deps */





var FormStep2_Component = function Component(_ref) {
  var setDataBanks = _ref.setDataBanks,
      setForm2Data = _ref.setForm2Data,
      form2Data = _ref.form2Data,
      savedBanks = _ref.savedBanks;
  (0,react.useEffect)(function () {
    var newDataBanks = (0,toConsumableArray/* default */.Z)(savedBanks.current);

    switch (form2Data.deposit) {
      case "1":
        newDataBanks = newDataBanks.filter(function (bank) {
          return bank.initial_deposit >= 0 && bank.initial_deposit <= 1000;
        });
        break;

      case "2":
        newDataBanks = newDataBanks.filter(function (bank) {
          return bank.initial_deposit <= 10000;
        });
        break;

      case "3":
        newDataBanks = newDataBanks.filter(function (bank) {
          return bank.initial_deposit <= 50000;
        });
        break;

      default:
        break;
    }

    if (form2Data.isRemote === "0") {
      newDataBanks = newDataBanks.filter(function (bank) {
        return bank.is_remote_opening;
      });
    }

    setDataBanks(newDataBanks);
  }, [form2Data]);

  var onDepositClick = function onDepositClick(deposit) {
    setForm2Data(FormStep2_objectSpread(FormStep2_objectSpread({}, form2Data), {}, {
      deposit: deposit
    }));
  };

  var onRemoteClick = function onRemoteClick(isRemote) {
    setForm2Data(FormStep2_objectSpread(FormStep2_objectSpread({}, form2Data), {}, {
      isRemote: isRemote
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "1. What is your acceptable level of initial deposit for opening an offshore bank account?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onDepositClick("1");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.deposit === "1" ? " bg-bbc-primary text-white" : ""),
          children: "0 - US$ 1000"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onDepositClick("2");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.deposit === "2" ? " bg-bbc-primary text-white" : ""),
          children: "US$ 1001 - US$ 10,000"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onDepositClick("3");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.deposit === "3" ? " bg-bbc-primary text-white" : ""),
          children: "US$ 10,001 - US$ 50,000"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onDepositClick("4");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.deposit === "4" ? " bg-bbc-primary text-white" : ""),
          children: "Above US$ 50,000"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "2. Can you afford a personal visit of all necessary company\u2019s members to bank\u2019s location to perform due diligence process?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onRemoteClick("1");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.isRemote === "1" ? " bg-bbc-primary text-white" : ""),
          children: "Yes, of course"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onRemoteClick("0");
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form2Data.isRemote === "0" ? " bg-bbc-primary text-white" : ""),
          children: "No, I need a remote opening"
        })]
      })]
    })]
  });
};

/* harmony default export */ var FormStep2 = (FormStep2_Component);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/form/FormStep3.js


function FormStep3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormStep3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormStep3_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormStep3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/exhaustive-deps */





var FormStep3_Component = function Component(_ref) {
  var dataBanks = _ref.dataBanks,
      setScoreResult = _ref.setScoreResult;

  var _useState = (0,react.useState)({
    question1: false,
    question2: false
  }),
      conditions = _useState[0],
      setConditions = _useState[1];

  var _useState2 = (0,react.useState)({
    question1: {
      answer: null,
      score: 0
    },
    question2: {
      answer: null,
      score: 0
    },
    question3: {
      answer: null,
      score: 0
    },
    question4: {
      answer: null,
      score: 0
    },
    question5: {
      answer: null,
      score: 0
    }
  }),
      form3Data = _useState2[0],
      setForm3Data = _useState2[1];

  var updateScore = function updateScore(fieldName, answer, score) {
    var scoreTemp = FormStep3_objectSpread({}, form3Data);

    scoreTemp[fieldName] = {
      answer: answer,
      score: score
    };
    setForm3Data(scoreTemp);
    var scoreCounter = 0;
    var statusTemp = "NONE";
    Object.values(scoreTemp).forEach(function (element) {
      scoreCounter += element.score;
    });

    if (scoreTemp.question1.answer === 2 && scoreTemp.question2.answer === 1) {
      scoreCounter -= scoreTemp.question2.score;
    } // If (scoreCounter <= 0) {
    //   StatusTemp = "NONE";
    // } else


    if (scoreCounter < 5) {
      statusTemp = "LOW";
    } else if (scoreCounter >= 5 && scoreCounter <= 7) {
      statusTemp = "MEDIUM";
    } else {
      statusTemp = "HIGH";
    }

    var percent = scoreCounter > 0 ? scoreCounter / 11 * 100 : 0;
    setScoreResult({
      status: statusTemp,
      percentage: percent
    });
  };

  var selectQuestion1 = function selectQuestion1(fieldName, answer, score) {
    updateScore(fieldName, answer, score);

    var conditionTemps = FormStep3_objectSpread({}, conditions);

    if (answer === 1) {
      conditionTemps.question2 = true;
    } else if (answer === 2) {
      conditionTemps.question2 = false;
    }

    setConditions(conditionTemps);
  };

  (0,react.useEffect)(function () {
    if (Array.isArray(dataBanks) && dataBanks.length > 0) {
      var conditionTemps = FormStep3_objectSpread({}, conditions);

      var is_HK_Sing = false;
      var is_Others = false;
      dataBanks.forEach(function (bank) {
        if (bank.Country.id === 98 || bank.Country.id === 191) {
          is_HK_Sing = true;
        } else {
          is_Others = true;
        }
      });

      if (is_HK_Sing && is_Others) {
        conditionTemps.question1 = true;
        conditionTemps.question2 = false;
      } else if (is_HK_Sing && !is_Others) {
        conditionTemps.question1 = false;
        conditionTemps.question2 = true;
      } else {
        conditionTemps.question1 = false;
        conditionTemps.question2 = false;
      }

      setConditions(conditionTemps);
    }
  }, [dataBanks]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [conditions.question1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "Where are you going to open your bank account?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return selectQuestion1("question1", 1, 0);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question1.answer === 1 ? " bg-bbc-primary text-white" : ""),
          children: "Onshore banks i.e. Singapore, Hong Kong"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return selectQuestion1("question1", 2, 0);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question1.answer === 2 ? " bg-bbc-primary text-white" : ""),
          children: "Offshore banks i.e. Belize, BVI, Mauritius,..."
        })]
      })]
    }), conditions.question2 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "Does your applying company have partners located in the same region with your chosen bank?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question2", 1, 2);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question2.answer === 1 ? " bg-bbc-primary text-white" : ""),
          children: "Yes"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question2", 2, 0);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question2.answer === 2 ? " bg-bbc-primary text-white" : ""),
          children: "No"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "1. How long have your applying company been in the business?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question3", 1, 5);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question3.answer === 1 ? " bg-bbc-primary text-white" : ""),
          children: "An established bussiness or expansion of an established bussiness"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question3", 2, 0);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question3.answer === 2 ? " bg-bbc-primary text-white" : ""),
          children: "A total newcomer with a well-defined bussiness plan"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "2. What types of account does your applying company intend to open?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question4", 1, 2);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question4.answer === 1 ? " bg-bbc-primary text-white" : ""),
          children: "Trading account"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question4", 2, -2);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question4.answer === 2 ? " bg-bbc-primary text-white" : ""),
          children: "Holding account"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 lg:mb-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 font-medium",
        children: "3. Does your applying company perform book keeping and annual auditing?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-2 gap-x-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question5", 1, 2);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question5.answer === 1 ? " bg-bbc-primary text-white" : ""),
          children: "Yes"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return updateScore("question5", 2, -2);
          },
          className: "mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ".concat(form3Data.question5.answer === 2 ? " bg-bbc-primary text-white" : ""),
          children: "No"
        })]
      })]
    })]
  });
};

/* harmony default export */ var FormStep3 = (FormStep3_Component);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/SendForm/index.js




function SendForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SendForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SendForm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SendForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var FormSend = function FormSend(_ref) {
  var triggerName = _ref.triggerName,
      form1Data = _ref.form1Data,
      step = _ref.step;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert;

  var recaptchaRef = (0,react.useRef)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var token, GAUserID, newData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return recaptchaRef.current.executeAsync();

            case 3:
              token = _context.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                newData = SendForm_objectSpread(SendForm_objectSpread({}, step.data), {}, {
                  client_id: GAUserID ? GAUserID : "",
                  website_id: "1",
                  email: data.email,
                  subject: "Bank account support",
                  is_merchant: form1Data.values.merchantAccount === "1" ? "Yes" : "No",
                  nation_member: Array.isArray(form1Data.values.memberNationalities) ? form1Data.values.memberNationalities.map(function (item) {
                    return item.name;
                  }) : [],
                  nation_partner: Array.isArray(form1Data.values.partnerCountries) ? form1Data.values.partnerCountries.map(function (item) {
                    return item.name;
                  }) : []
                }); // Axios
                //   .post(
                //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/minitool_contact`,
                //     NewData,
                //     {
                //       Headers: {
                //         "captcha-response": token,
                //       },
                //     }
                //   )

                (0,post/* default */.Z)({
                  api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/minitool_contact"),
                  data: newData,
                  token: token
                }).then(function (res) {
                  if (res.state) {
                    (0,trigger/* default */.Z)("contact_form", data, triggerName);
                    openAlert(3000, "success"); // CloseModal();
                  } else {
                    openAlert(3000, "error");
                  }

                  setIsLoading(false);
                })["catch"](function (err) {
                  openAlert(3000, "error");
                  setIsLoading(false);
                  console.log(err);
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "col-12 mb-2 lg:col-9",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(onSubmit),
      id: "form-email",
      className: "flex justify-between overflow-hidden rounded-[41px] border bg-white p-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", SendForm_objectSpread(SendForm_objectSpread({}, register("email", {
        required: {
          value: true,
          message: "This field is required."
        },
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "invalid email address"
        }
      })), {}, {
        className: "form-control flex-auto rounded-[41px] border-0 bg-white px-6 py-2 shadow-none focus:outline-none",
        placeholder: "Enter your e-mail address"
      })), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "submit",
        className: "flex items-center px-1 leading-none",
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "flex items-center pr-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
            className: "w-9 animate-spin",
            size: 20
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/icons/send.svg",
          width: 36,
          height: 36,
          alt: "send"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " invisible h-0 w-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
          ref: recaptchaRef,
          sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
          badge: "inline",
          size: "invisible"
        })
      })]
    }), errors && errors.email && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "my-2 text-center text-sm tracking-[0.15px] text-red-500",
      children: errors.email.message
    })]
  });
};
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/banking-tool/index.js



function banking_tool_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function banking_tool_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { banking_tool_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { banking_tool_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* eslint-disable react-hooks/exhaustive-deps */

















var dataStep = [{
  id: 1,
  name: "Banking Requirement",
  sub_step: []
}, {
  id: 2,
  name: "Personal Freference",
  sub_step: []
}, {
  id: 3,
  name: "Successful Rate Assessment",
  sub_step: []
}];

var Tool = function Tool() {
  // Const { openAlert } = useContext(ToastContext);
  var _useState = (0,react.useState)(1),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = (0,react.useState)([]),
      countries = _useState2[0],
      setCountries = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      dataBanks = _useState3[0],
      setDataBanks = _useState3[1];

  var _useState4 = (0,react.useState)({
    values: {
      businessField: ""
    }
  }),
      form1Data = _useState4[0],
      setForm1Data = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      form2Data = _useState5[0],
      setForm2Data = _useState5[1];

  var _useState6 = (0,react.useState)({
    percentage: 0,
    status: "NONE"
  }),
      scoreResult = _useState6[0],
      setScoreResult = _useState6[1];

  var _useState7 = (0,react.useState)(1),
      screenToggle = _useState7[0],
      setScreenToggle = _useState7[1];

  var _useState8 = (0,react.useState)({}),
      errorsForm1 = _useState8[0],
      setErrorsForm1 = _useState8[1];

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert,
      setOpenAlert = _useContext.setOpenAlert;

  var savedBanks = (0,react.useRef)([]);

  var _useForm = (0,index_esm/* useForm */.cI)(),
      clearErrors = _useForm.clearErrors,
      reset = _useForm.reset,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  function fetchCountries() {
    return _fetchCountries.apply(this, arguments);
  }

  function _fetchCountries() {
    _fetchCountries = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,get/* default */.Z)({
                url: "".concat("https://core.test-lp.bbcincorp.com", "/api/onboarding/country")
              });

            case 2:
              response = _context2.sent;

              if (response.data && response.data.length > 0) {
                setCountries(response.data.map(function (item) {
                  return banking_tool_objectSpread(banking_tool_objectSpread({}, item), {}, {
                    label: item.name,
                    value: item.id
                  });
                }));
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _fetchCountries.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    try {
      // Async function fetchCountries() {
      //   Const response = await axios.get(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`
      //   );
      //   If (response.data && response.data.data) {
      //     SetCountries(
      //       Response.data.data.map((item) => ({
      //         ...item,
      //         Label: item.name,
      //         Value: item.id,
      //       }))
      //     );
      //   }
      // }
      fetchCountries();
    } catch (error) {
      console.error();
    }
  }, []);
  (0,react.useEffect)(function () {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });

    if (errors.email) {
      clearErrors();
    }
  }, [step]);

  var toggleScreen = function toggleScreen() {
    if (screenToggle === 1) {
      setScreenToggle(2);
    } else {
      setScreenToggle(1);
    }
  };

  var isNextDisabled = function isNextDisabled() {
    if (step === 3 || dataBanks.length === 0) {
      return true;
    }

    if (step === 1) {
      var values = form1Data.values;
      var con1 = !values.incorporationCountry || !values.incorporationCountry.value;
      var con2 = !values.businessField || values.businessField.trim() === "";
      var con3 = !values.merchantAccount;
      var con4 = !values.memberNationalities || !Array.isArray(values.memberNationalities) || Array.isArray(values.memberNationalities) && values.memberNationalities.length === 0;
      var con5 = !values.partnerCountries || !Array.isArray(values.partnerCountries) || Array.isArray(values.partnerCountries) && values.partnerCountries.length === 0;
      return con1 || con2 || con3 || con4 || con5;
    }

    if (step === 2) {
      return !form2Data.deposit || !form2Data.isRemote;
    }
  };

  var onNext = function onNext() {
    if (!isNextDisabled()) {
      if (step === 1) {
        savedBanks.current = dataBanks;
      }

      if (step < 3) {
        setStep(step + 1);
      }
    }
  };

  var onBack = function onBack() {
    if (step === 3) {
      setScoreResult({
        percentage: 0,
        status: "NONE"
      });
    }

    if (step === 2) {
      setDataBanks(savedBanks.current);
      setForm2Data({});
    }

    if (step > 1) {
      setStep(step - 1);
    }
  };

  var handleReset = function handleReset() {
    setForm1Data({
      values: {
        businessField: ""
      }
    });
    setForm2Data({});
    setStep(1);
    setScoreResult({
      percentage: 0,
      status: "NONE"
    });
    setDataBanks([]);
    savedBanks.current = []; // ClearErrors();

    reset({
      email: ""
    });
    setErrorsForm1({});
  };

  var onResetClick = function onResetClick() {
    var isResetDisabled = Object.keys(form1Data.values).length <= 1 && form1Data.values.businessField === "";

    if (!isResetDisabled) {
      openAlert(false, "custom", {
        bgAlert: "bg-white",
        element: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: ["Are you sure?", " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setOpenAlert(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                handleReset();
                setOpenAlert(false);
              },
              children: "Yes"
            })]
          })]
        })
      });
    }
  };

  var onTalkClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Tawk_API.toggle();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onTalkClick() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container ".concat((Styles_module_default()).wrapper),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-0 lg:mb-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepBar/* default */.Z, {
          step: step,
          data: dataStep
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 lg:col-8 lg:block ".concat(screenToggle === 1 ? "block" : " hidden"),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:shadow-bbc h-full rounded-lg bg-inherit px-0 py-0 shadow-none lg:bg-white lg:px-16 lg:py-10",
            children: [step === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(FormStep1, {
              countries: countries,
              form1Data: form1Data,
              setForm1Data: setForm1Data,
              setDataBanks: setDataBanks,
              errors: errorsForm1,
              setErrors: setErrorsForm1
            }), step === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(FormStep2, {
              dataBanks: dataBanks,
              setDataBanks: setDataBanks,
              form2Data: form2Data,
              setForm2Data: setForm2Data,
              savedBanks: savedBanks
            }), step === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(FormStep3, {
              dataBanks: dataBanks,
              setScoreResult: setScoreResult
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 flex justify-between lg:mb-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: onBack,
                disabled: step === 1 || isSubmitting,
                className: "".concat(step === 1 || isSubmitting ? "cursor-not-allowed text-bbc-neutral-600" : "cursor-pointer text-bbc-brand-500", " font-medium"),
                children: "Back"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: onResetClick,
                disabled: Object.keys(form1Data.values).length <= 1 && form1Data.values.businessField === "" || isSubmitting,
                className: "".concat(Object.keys(form1Data.values).length <= 1 && form1Data.values.businessField === "" || isSubmitting ? "cursor-not-allowed text-bbc-neutral-600" : "cursor-pointer text-bbc-brand-500", " btn-outline-primary font-medium"),
                children: "Reset"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: onNext,
                disabled: isNextDisabled() || isSubmitting,
                className: "".concat(isNextDisabled() || isSubmitting ? "cursor-not-allowed text-bbc-neutral-600" : "cursor-pointer text-bbc-brand-500", " btn-outline-primary font-medium "),
                children: "Next"
              })]
            }), step === 3 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 lg:mb-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-4 text-center font-medium",
                children: "Need more support with your banking choices and application? Leave your details and we\u2019ll get in touch."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "row m-0 mb-2 justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormSend, {
                    haveCheckBox: true,
                    checkedId: 21,
                    unCheckId: 23,
                    triggerName: "Banking Tool",
                    apiLink: "/api/portal/contact_form/minitool_contact",
                    form1Data: form1Data,
                    step: step
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-2 text-center",
                children: "Or"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                  onClick: onTalkClick,
                  children: "Talk To Us"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-2 font-medium",
                children: "*Note:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-sm font-normal italic",
                children: "The information provided in this tool is for general reference purpose only. We strongly recommend you contacting us to receive specific advice contingent on your case."
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 flex-col lg:col-4 lg:flex ".concat(screenToggle === 2 ? "" : "hidden"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:shadow-bbc mb-0 rounded-lg bg-bbc-main p-6 shadow-none lg:mb-6 lg:bg-white",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-4 text-center font-medium",
              children: "Your chances of getting approved"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Progress/* default */.Z, {
                percent: scoreResult.percentage,
                text: scoreResult.status,
                strokeWidth: "7",
                trailWidth: "7",
                strokeColor: "#007EFF",
                trailColor: "#E5E5E5",
                className: "inline-block",
                style: {
                  width: "170px"
                }
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:shadow-bbc flex-auto rounded-lg bg-bbc-main px-0 py-6 shadow-none lg:bg-white lg:px-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-4 text-center lg:text-left",
              children: "List of proposed banks based on your answers (in desc order of suitability)"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-medium text-bbc-brand-500",
                children: "Bank: "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: dataBanks.length === 0 ? "No results" : dataBanks.length
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "overflow-y-auto",
              style: {
                height: "480px"
              },
              children: dataBanks.map(function (bank, index) {
                var _bank$Country;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mb-2 flex justify-between rounded-md border border-bbc-neutral-500 p-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "mb-1 font-medium",
                      children: bank.name
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-xs font-normal",
                      children: bank === null || bank === void 0 ? void 0 : (_bank$Country = bank.Country) === null || _bank$Country === void 0 ? void 0 : _bank$Country.name
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "assets".concat(bank.image),
                    wrapper: {
                      className: "self-center"
                    },
                    alt: "bank"
                  })]
                }, index);
              })
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: toggleScreen,
      className: "text-uppercase fixed bottom-0 z-20 flex w-full justify-center bg-white px-0 py-5 font-medium text-bbc-primary lg:hidden",
      style: {
        boxShadow: "0 -4px 8px rgb(0 0 0 / 25%)"
      },
      children: [screenToggle === 1 && "YOUR RESULT IN HERE", screenToggle === 2 && "BACK"]
    })]
  });
};

function BankingTool(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tool, {
      data: data
    })
  });
}
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/banking-tool/index.js



var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingTool, {})
    })
  });
}

/***/ }),

/***/ 67764:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/guide-and-tool/banking-tool",
      function () {
        return __webpack_require__(53667);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"Styles_selectBox__3FpC3","wrapper":"Styles_wrapper__tqnxR"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9885,9973,9669,4090,9738,9663,9774,2888,179], function() { return __webpack_exec__(67764); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);